<template>
    <div class="newsList">
        <div class="wrap">
            <Breadcrumb separator=">">
                <BreadcrumbItem to="/about">我们是</BreadcrumbItem>
                <BreadcrumbItem :to="{name:'newsList',query:{nodeId:contentInfo.nodeId}}">新闻中心</BreadcrumbItem>
                <BreadcrumbItem>详情</BreadcrumbItem>
            </Breadcrumb>
            <Row>
                <Col span="16">
                    <div class="news-wrap">
                        <div class="row">
                            <div class="news-detail col-md-8">
                                <div class="news-tit">
                                    <h2>{{contentInfo.title}}</h2>
                                    <p class="time">{{contentInfo.publishDate}}</p>
                                </div>
                                <div class="news-detail-con" v-html="contentInfo.content">
                                   <!-- {{contentInfo.content}} -->
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="hotNews">
                        <div class="newsBT">热门文章</div>
                        <div class="hotNews-list">
                            <Timeline>
                                <TimelineItem  v-for="(list, index) in articleList" :key="index">
                                    <a  @click="clickDetail(list.id)">
                                        <p class="content">{{list.title}}</p>
                                        <p class="time">{{list.publishDate}}</p>
                                    </a>
                                    
                                </TimelineItem>

                            </Timeline>
                        </div>
                    </div>
                </Col>
            </Row>

        </div>
    </div>
</template>

<script>
    export default {
        name: "newsList",
        components:{

        },
        data(){
            return{
                loading:false,
                articleList:[
                ],
                contentInfo:{}
            }
        },
        methods:{
            geContentById(id) {
                this.loading = true;
                this.$http.get("/api/services/app/CommonWeb/GetContentInfoById?id="+id)
                    .then(res => {
                        this.contentInfo = res.data.result;
                        this.getHotNews();
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getHotNews() {
                this.loading = true;
                this.$http.get("/api/services/app/CommonWeb/GetHotContents?nodeName=运管新闻")
                    .then(res => {
                        this.articleList = res.data.result;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            clickDetail(id){
                console.log(id);
                this.id=id;
                 this.geContentById(this.id);
                // this.$router.push({path: '/newsDetail',query:{id:id}});
            },
        },
        mounted(){
            this.id = this.$route.query.id;
            console.log(this.id);
            this.geContentById(this.id);
            
        },
    }
</script>

<style lang="less">
    .newsList{
        padding:20px 0;
        background-color: #fff;
        .newsBT{
            font-size:18px;
            color:#000;
            margin:20px 0;
        }
        .newsList-con{
            ul{
                li{
                    display: flex;
                    flex-flow: row;
                    border: 1px solid #E3E3E3;
                    margin-bottom:30px;
                    .newsImg{
                        line-height:0;
                    }
                    .news-con{
                        padding:24px 30px 16px 30px;
                        .news-tit{
                            font-size:18px;
                            color:#000;
                            margin-bottom:16px;
                        }
                        .news-dec{
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            margin-bottom:20px;
                            color:#999;
                            font-size:14px;
                            height:64px;
                        }
                        .news-date{
                             color:#666;
                            font-size:12px;
                        }
                    }
                }
                li:hover{
                    border: 1px solid #F5F5F5;
                    box-shadow: 0px 0px 20px 0px rgba(151, 151, 151, 0.5);
                }
            }
        }
        .news-detail {
            background: #fff;
            padding: 0;
            margin-bottom: 2rem;
        }

        .news-detail .news-tit {
            padding: 2rem 2rem 1.5rem 2rem;
            border-bottom: 1px solid #ddd;
        }

        .news-detail .news-tit h2 {
            font-size: 1.8rem;
            font-weight: bold;
            color: #12284c;
        }

        .news-detail .news-tit .time {
            color: #888;
            padding-top: 5px;
        }

        .news-detail-con {
            padding: 2rem;
            font-size: 1.3rem;
            text-align: center
        }

        .news-detail-con img {
            padding:0;
            margin: 0 auto;
            display: block;
            line-height:0;
            max-width:100%;

        }

        .news-detail-con p {
            text-align: left;
            margin: 1rem 0;
            text-indent: 2.4rem;
        }

        .hotNews{
            padding-left:30px;
            .hotNews-list{
                background: #FAFAFA;
                box-shadow: 0px 0px 1px 0px rgba(151, 151, 151, 0.5);
                padding:30px 20px;
                a{
                    color:#000000;
                }
            }
        }
        .ivu-timeline-item-head{
            background-color: #3377E7;
        }
        .ivu-timeline-item-tail,
        .ivu-timeline-item-head-blue{
            border-color:#3377E7;
            color:#3377E7;
        }
        .content{
            font-size: 14px;
            font-weight: bold;
        }
        .content:hover{
            color:#3377E7;
        }
        .time{
            padding-left: 5px;
            padding-top:10px;
        }
    }
</style>